var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outer"},[_vm._t("outer"),_c('div',{staticClass:"inner",style:({ minWidth: ((100 / _vm.scale) + "%"), transform: ("scale(" + _vm.scale + ")") })},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }